export enum TimePeriod { AllTime, Today, ThisWeek, Fortnight, ThisMonth, Custom }

export interface IReportFilters {
    startDate?: Date;
    endDate?: Date;
    timePeriod: TimePeriod;
    searchString?: string | undefined;
}


// WEBPACK FOOTER //
// ./src/contracts/IReportFilters.ts